import { getCookie } from '@utiljs/cookie';
import Modal from '@roo/roo/Modal';
import { reportCustomError } from '@utils/owlReporter';
import doLogout from '../../utils/doLogout';

/**
 * 登录状态检测，主要检测一下两类场景
 *
 * 1. 商家在两个tab中分别登录两个不同的账号
 * 2. 商家在两个tab中登录同一个账号，然后在其中1个tab内登出
 *
 * 遇到以上两种场景需要强制刷新页面
 */

const sharedModalProps = {
    closable: false,
    backdropClosable: false,
    showCancelButton: false,
};

const initialAcctId = getCookie('acctId');

const startDetect = () => {
    window.setInterval(() => {
        const lastestAcctIdFromCookie = getCookie('acctId');
        if (initialAcctId && lastestAcctIdFromCookie && initialAcctId !== lastestAcctIdFromCookie) {
            // cookie中最新的acctId和缓存的值一致，说明商家在其它tab换账号登录了
            Modal.confirm({
                title: '检测到多账号登录',
                children: `您已在其它标签页登录另一个账号${`(ID:${lastestAcctIdFromCookie})`}，10s后将自动为您刷新页面`,
                confirmText: '立即刷新',
                onConfirm: () => window.location.reload(),
                ...sharedModalProps,
            });
            setTimeout(() => {
                window.location.reload();
            }, 10 * 1000);

            reportCustomError({
                level: 'WARN',
                name: `多账号登录`,
                message: `多账号登录：原账号(${initialAcctId})，新账号(${lastestAcctIdFromCookie})`,
            });
        } else if (!lastestAcctIdFromCookie && !getCookie('token')) {
            // acctId 和 token 都没了，说明商家从其它tab登出了
            Modal.confirm({
                title: '检测到退出登录',
                children: `您已在其它标签页登出商家中心，10s后将自动为您跳转登录页`,
                confirmText: '立即跳转',
                onConfirm: () => doLogout(),
                ...sharedModalProps,
            });
            setTimeout(() => {
                doLogout();
            }, 10 * 1000);

            reportCustomError({
                level: 'WARN',
                name: `非当前页面退登`,
                message: `非当前页面退登：账号(${initialAcctId})`,
            });
        }
    }, 20 * 1000);
};

export default {
    startDetect,
};
